export const LOAD_TERM_WORDING = 'util/LOAD_TERM_WORDING';
export const LOAD_TERM_WORDING_SUCCESS = 'util/LOAD_TERM_WORDING_SUCCESS';
export const LOAD_TERM_WORDING_ERROR = 'util/LOAD_TERM_WORDING_ERROR';

export const LOAD_PRIVACY_WORDING = 'util/LOAD_PRIVACY_WORDING';
export const LOAD_PRIVACY_WORDING_SUCCESS = 'util/LOAD_PRIVACY_WORDING_SUCCESS';
export const LOAD_PRIVACY_WORDING_ERROR = 'util/LOAD_PRIVACY_WORDING_ERROR';

export const LOAD_LOGO = 'util/LOAD_LOGO';
export const LOAD_LOGO_SUCCESS = 'util/LOAD_LOGO_SUCCESS';
export const LOAD_LOGO_ERROR = 'util/LOAD_LOGO_ERROR';
